import { History, Location } from 'history';
import { Provider } from 'mobx-react';
import * as querystring from 'querystring';
import * as React from 'react';
import { Redirect, RouteComponentProps, withRouter } from 'react-router';
import { API } from '../../api/api';
import { FetchAPI } from '../../api/fetch';
import { Translator } from '../../i18n/translator';
import { AppStore } from '../../stores/app-store';
import { AppHeader } from './app-header';

export class AppInner extends React.Component<RouteComponentProps<void>> {
  private readonly app: AppStore;
  private readonly api = new FetchAPI();

  constructor(props: RouteComponentProps<void>) {
    super(props);
    this.app = new AppStore(guessCulture(props.location));
  }

  public render() {
    if (!this.app.booking && this.props.location.pathname !== '/login')
      return <Redirect to="/login"/>;

    return (
      <Provider api={this.api} app={this.app} t={this.app.translator.translate}>
        <div className="app">
          <AppHeader/>
          {this.props.children}
        </div>
      </Provider>
    );
  }
}

function guessCulture(location: Location) {
  const hostnames: { readonly [host: string]: string } = {
    'mycompensation.volaris.com': 'en-US',
    'micompensacion.volaris.com': 'es-MX',
  };
  if (location.search)
    return querystring.parse(location.search.slice(1)).culture;
  if (window.location.hostname in hostnames)
    return hostnames[window.location.hostname];
  return 'es-MX';
}

export interface InjectAPI {
  readonly api: API;
}

export interface InjectApp {
  readonly app: AppStore;
}

export interface InjectHistory {
  readonly history: History;
}

export interface InjectTranslate {
  readonly t: Translator['translate'];
}

export const App = withRouter(AppInner) as React.ComponentClass;



// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./src/components/app/app.tsx